import * as React from "react";
import { Icon } from "@iconify/react";
import firebase from "firebase";
import { removeAllCookies } from "../../../../utils/cookies";
import SocialSignInButtonWithLogo from "../../../../components/buttons/SocialSignInButtonWithLogo";

export interface GoogleSignInProps {
  handleCreateCustomToken: any;
  backText: any;
  backColour: any;
}

/* Google sign in page */
const GoogleSignIn: React.FunctionComponent<GoogleSignInProps> = ({
  handleCreateCustomToken,
  backText,
  backColour,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = () => {
    setIsLoading(true);
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result: any) => {
        if (result && result.user) {
          firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
              firebaseUser.getIdToken(true).then(async function (idToken) {
                handleCreateCustomToken(idToken);
              });
            }
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  return (
    <SocialSignInButtonWithLogo
      handleClick={handleClick}
      logoSrc={
        <Icon
          icon="ri:google-fill"
          style={{
            width: "32px",
            minWidth: "32px",
            height: "32px",
          }}
          color={backText}
        />
      }
      isLoading={isLoading}
      backColour={backColour}
      isFullWidth={true}
      labelText="Sign in with Google"
      backText={backText}
    />
  );
};

export default GoogleSignIn;
